import http from './http';
import User from './models/User';

export class UserAPI {
	static USER_ENDPOINT = 'Dealer/GetDealer';
	static USER_SEARCH_ENDPOINT = 'Dealer/GetChildToImpersonate';

	static IMPERSONATE_ENDPOINT = 'Dealer/Impersonate';
	static REVERSE_IMPERSONATION_ENDPOINT = 'Dealer/ReverseImpersonation';

	static parse_users(users) {
		const impersonated = users.Impersonated;

		return {
			current: new User(users.LoggedIn),
			impersonated: impersonated ? new User(impersonated) : null,
		};
	}

	fetchUser() {
		return http
			.get(UserAPI.USER_ENDPOINT)
			.then(users => UserAPI.parse_users(users));
	}

	searchUser(id) {
		return http
			.get(
				`${UserAPI.USER_SEARCH_ENDPOINT}?userIdentifier=${encodeURIComponent(
					id
				)}`
			)
			.then(user => new User(user));
	}

	impersonate(businessPartner = '') {
		return http.post(
			`${UserAPI.IMPERSONATE_ENDPOINT}?userIdentifier=${businessPartner}`
		);
	}

	reverseImpersonation() {
		return http.post(UserAPI.REVERSE_IMPERSONATION_ENDPOINT);
	}
}

export default new UserAPI();



// WEBPACK FOOTER //
// ./src/api/user.js